import React, {
  Fragment,
  useState,
  useContext,
  useEffect,
  useCallback,
} from "react";
// import clsx from "clsx";
import { Theme, makeStyles } from "@material-ui/core/styles";
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Collapse,
} from "@material-ui/core";
import WidgetSummary from "../../components/widget-summary";
import { MainContext } from "../../context/main";
import DashboardAllUser from "../../container/dashboard-alluser";
import DashboardUser from "../../container/dashboard-user";
import { getDepartmentList } from "../../apis/department";
import { getProjectAggregate, getProjectNoDesigns } from "../../apis/project";
import _ from "lodash";
import { getUserList } from "../../apis/user";

const useStyle = makeStyles((theme: Theme) => ({
  root: {
    height: `calc(100% - ${theme.spacing(4)}px)`,
    width: `calc(100% - ${theme.spacing(4)}px)`,
    padding: theme.spacing(2),
  },
}));
interface Idepartment {
  dep_id: number;
  name: string;
  _id: string;
}
const Dashboard = () => {
  const classes = useStyle();
  const [groupDasboard, setgroupDasboard] = useState<
    undefined | "admin" | "user"
  >(undefined);
  const [initedPage, setinitedPage] = useState<Boolean>(false);

  const mainContext = useContext(MainContext);
  const { userInfo } = mainContext;
  const [departmentList, setdepartmentList] = useState<Idepartment[]>([]);
  const [selectDepartment, setselectDepartment] = useState<any>(0);
  const [ProjectCount, setProjectCount] = useState<any>([
    { icon: "allProject", value: 0, label: "Project" },
    { icon: "inProcess", value: 0, label: "In Process" },
    { icon: "complete", value: 0, label: "Complete" },
  ]);
  const [userList, setuserList] = useState<any>([]);
  const [userCount, setuserCount] = useState<any>(0);
  const initData = useCallback(async () => {
    const abortController = new AbortController();
    const rsDepList = await getDepartmentList(abortController);

    if (rsDepList.data) {
      setdepartmentList(rsDepList.data);
    }
    return () => {
      abortController.abort();
    };
  }, []);

  useEffect(() => {
    initData();
    return () => {};
  }, [initData]);

  useEffect(() => {
    if (userInfo && (userInfo?.role === "admin" || userInfo?.role === "root")) {
      setgroupDasboard("admin");
    } else {
      setgroupDasboard("user");
    }
    setinitedPage(true);
    return () => {};
  }, [userInfo]);

  const getProjectDetail = useCallback(
    async (sd: string | number) => {
      const abortController = new AbortController();
      const getProjectCount = await getProjectAggregate(
        abortController,
        sd ? "department_id" : null,
        sd ? sd : null
      );
      const getProjectStatus = await getProjectAggregate(
        abortController,
        sd ? "department_id" : "group",
        sd ? `${sd}&group=status` : "status"
      );

      if (getProjectCount.data.length && getProjectStatus.data.length) {
        const status1 = getProjectStatus.data.find(
          (rs: any) => rs._id.status === 1
        );

        const status2 = getProjectStatus.data.find(
          (rs: any) => rs._id.status === 2
        );

        setProjectCount([
          {
            icon: "allProject",
            value: getProjectCount.data[0].count,
            label: "Project",
          },
          {
            icon: "inProcess",
            value: status1 ? status1.count : 0,
            label: "In Process",
          },
          {
            icon: "complete",
            value: status2 ? status2.count : 0,
            label: "Complete",
          },
        ]);
      } else {
        setProjectCount([
          { icon: "allProject", value: 0, label: "Project" },
          { icon: "inProcess", value: 0, label: "In Process" },
          { icon: "complete", value: 0, label: "Complete" },
        ]);
      }
      return () => {
        abortController.abort();
      };
    },

    []
  );

  useEffect(() => {
    getProjectDetail(selectDepartment);
    return () => {};
  }, [selectDepartment, getProjectDetail]);

  const initUser = useCallback(async () => {
    const userlist = await getUserList();
    if (userlist.data) {
      const abortController = new AbortController();
      const getProj = await getProjectNoDesigns();
      const findProjectDep = getProj.data.filter((rs: any) =>
        selectDepartment
          ? rs.department_id === selectDepartment
          : rs.department_id
      );
      const uniqArray = _.uniqBy(findProjectDep, "created_by");

      const ReStrucData = userlist.data.map(async (rs: any) => {
        const { _id } = rs;

        const checkUserStatus: any = uniqArray.find(
          (fd: any) => fd.created_by === _id
        );

        if (checkUserStatus) {
          const getProjectStatus = await getProjectAggregate(
            abortController,
            selectDepartment ? "department_id" : "group",
            selectDepartment
              ? `${selectDepartment}&group=created_by,status`
              : "created_by,status"
          );

          const filtercount = getProjectStatus.data.filter(
            (sm: any) => sm._id.created_by === _id
          );

          const status0 = filtercount.find((rs: any) => rs._id.status === 0);
          const status1 = filtercount.find((rs: any) => rs._id.status === 1);
          const status2 = filtercount.find((rs: any) => rs._id.status === 2);

          const sumProject =
            Number(status0 ? status0.count : 0) +
            Number(status1 ? status1.count : 0) +
            Number(status2 ? status2.count : 0);

          return {
            id: rs._id,
            first_name: rs.first_name,
            last_name: rs.last_name,
            project: sumProject,
            inprocess: status1 ? status1.count : 0,
            complete: status2 ? status2.count : 0,
            created_at: rs.created_at,
            role: rs.role,
            department: checkUserStatus.department_id,
          };
        } else {
          return {
            id: rs._id,
            first_name: rs.first_name,
            last_name: rs.last_name,
            project: 0,
            inprocess: 0,
            complete: 0,
            created_at: rs.created_at,
            role: rs.role,
            department: undefined,
          };
        }
      });

      const resolve = await Promise.all(ReStrucData);

      setuserList(resolve);
      let count: number = 0;
      if (selectDepartment) {
        count = resolve.filter((rs: any) => rs.project).length;
      } else {
        count = resolve.length;
      }

      setuserCount(count);
    }
  }, [selectDepartment]);

  useEffect(() => {
    initUser();
    return () => {};
  }, [initUser]);

  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        {(userInfo?.role === "admin" || userInfo?.role === "root") && (
          <Fragment>
            <Grid item xs={4}>
              <FormControl variant="outlined" fullWidth margin="dense">
                <InputLabel id="demo-simple-select-outlined-label">
                  เลือกเขตการไฟฟ้า
                </InputLabel>
                <Select
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  label="เลือกเขตการไฟฟ้า"
                  value={selectDepartment}
                  onChange={(e) => {
                    setselectDepartment(e.target.value);
                  }}
                >
                  <MenuItem value={0}>
                    <em>All</em>
                  </MenuItem>

                  {departmentList.map((rs) => {
                    return (
                      <MenuItem key={rs._id} value={rs._id}>
                        <em>{rs.name}</em>
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={8} />
            <Grid
              item
              xs={4}
              onClick={() => {
                setgroupDasboard("admin");
              }}
            >
              <WidgetSummary
                selectable={Boolean(
                  userInfo?.role === "admin" || userInfo?.role === "root"
                )}
                data={[
                  {
                    icon: "allUser",
                    value: userCount,
                    label: "All User",
                  },
                ]}
                select={groupDasboard === "admin"}
              />
            </Grid>
          </Fragment>
        )}
        <Grid
          item
          xs={userInfo?.role === "admin" || userInfo?.role === "root" ? 8 : 12}
          onClick={
            userInfo?.role === "admin" || userInfo?.role === "root"
              ? () => {
                  setgroupDasboard("user");
                }
              : () => {}
          }
        >
          <WidgetSummary
            selectable={Boolean(
              userInfo?.role === "admin" || userInfo?.role === "root"
            )}
            data={ProjectCount}
            select={
              groupDasboard === "user" &&
              (userInfo?.role === "admin" || userInfo?.role === "root")
            }
          />
        </Grid>
        {initedPage && (
          <Grid item xs={12}>
            <Collapse in={Boolean(groupDasboard === "admin")}>
              <div>
                {userInfo?.role === "admin" || userInfo?.role === "root" ? (
                  <DashboardAllUser
                    selectDepartment={selectDepartment}
                    userList={userList}
                  />
                ) : (
                  <div />
                )}
              </div>
            </Collapse>
            <Collapse in={Boolean(groupDasboard === "user")}>
              <div>
                <DashboardUser selectDepartment={selectDepartment} />
              </div>
            </Collapse>
          </Grid>
        )}
      </Grid>
    </div>
  );
};

export default Dashboard;
